import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './CheckmarkIcon.scss'


const CheckmarkIcon = ({ className, style }) => (
  <div className={cx(s.icon, className)} style={style} />
)

CheckmarkIcon.propTypes = {
  className: PropTypes.string,
}


export default CheckmarkIcon
